import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerTwitterProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerTwitterProfileOverview = (props: InfluencerTwitterProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
